import useQueryExchanges from '../hooks/etc/useQueryExchanges'

export const useExchange = () => {
    const {data: exchangeData} = useQueryExchanges()

    const getExchangeData = (exchange_id: string) => {
        return exchangeData?.find(exchange => exchange?.name === exchange_id)
    }
    return {getExchangeData}
}
